import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import { useProjetosBanco } from "../hooks/useProjetosComBanco";
import { projetoEhDoTipo } from "../utils/projetos";

function RA() {
  const navigate = useNavigate();
  const todosProjetos = useProjetosBanco();
  const projetosRA = todosProjetos.filter((p) => projetoEhDoTipo(p, "RA"));

  const handleCardClick = (id) => {
    navigate(`/projeto/${id}`);
  };

  return (
    <div className="pagina-categoria">
      <h1>Projetos de Realidade Aumentada</h1>
      <div className="cards-container">
        {projetosRA.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
        ))}
      </div>
    </div>
  );
}

export default RA;

